import React from 'react'
import styled from 'styled-components'
import EditIcon from '@mui/icons-material/Edit'
import { color } from 'styles/colors'
import Table from 'components/Table'
import Resource, { ValidResourceTypes } from 'types/Resource'
import { screenSize } from 'styles/shared'

type ResourceProps = {
  type: ValidResourceTypes
  resource: Resource
}
type Props = {
  type: ValidResourceTypes
  resource: Resource
  onSuccessfulSubmission: () => void
  onClickEditResource:(val:ResourceProps)=>void
}

const PublishedCell = ({ type, resource, onClickEditResource }: Props) => {
  return (
    <S.TableCell>
      <div>
        <S.StatusRow>
          <S.Status draft={resource.draft}>{!resource.draft ? 'Published' : 'Not Published'}</S.Status>
          <S.EditIcon
            fontSize="small"
            color="primary"
            style={{ cursor: 'pointer' }}
            aria-label={`Edit Resource with title: ${resource.name}`}
            onClick={() => { onClickEditResource({ resource, type }) }}
          >
            Edit
          </S.EditIcon>
        </S.StatusRow>
      </div>
    </S.TableCell>
  )
}

export default PublishedCell

const S = {
  TableCell: styled(Table.Cell)`
    padding: 15px 0px 15px 15px;
    flex-basis: 20%;

    @media ${screenSize.small} {
      padding: 5px;
    }
  `,
  StatusRow: styled.div`
    display: inline-flex;
    align-items: center;
  `,
  EditIcon: styled(EditIcon)`
      color: ${color('EditIcon')};
      margin-left: 10px;
    `,
  Status: styled.div.withConfig({
    shouldForwardProp: (prop) => !['draft'].includes(prop)
  })<{ draft: boolean }>`
    display: inline-block;
    padding: 4px 10px;
    text-align: center;
    font-size: 12px;
    letter-spacing: 0;
    text-transform: uppercase;
    border: 1px solid ${color('border')};
    border-radius: 14px;
  
    ${({ draft }) => {
    if (!draft) {
      return `
        border-color: ${color('siteMessageEnabledStatusBorder')};
        background-color: ${color('positiveStatus')};
        color: ${color('siteMessageStatusEnabledText')};
      `
    } else {
      return ` 
        color: ${color('statusDisabledText')};
      `
    }
  }}`
}
